import { render, staticRenderFns } from "./dvBtn.vue?vue&type=template&id=4bd560bb&scoped=true"
import script from "./dvBtn.vue?vue&type=script&lang=js"
export * from "./dvBtn.vue?vue&type=script&lang=js"
import style0 from "./dvBtn.vue?vue&type=style&index=0&id=4bd560bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd560bb",
  null
  
)

export default component.exports